import React from "react";
import FilterSearch from "../../containers/contacts/contactsFilterSearch";

class ContactSearch extends React.Component {
	render() {
		return (
			<div className="bg-light p-4">
				<FilterSearch />
			</div>
		);
	}
}

export default ContactSearch;
